<div class="row flex-between-center border my-2">
  <div class="col-3 my-2">
    <labeled-content [label]="'general.name'">
      <label class="data-labels">{{
        person().firstName + " " + person().midName + " " + person().lastName
      }}</label>
    </labeled-content>
  </div>
  <div class="col-8 my-2">
    <labeled-content [label]="'general.formOfConnection'">
      <label class="data-labels">{{ person().connection.description }}</label>
    </labeled-content>
  </div>
</div>
